// 班级
import { apiGet, apiPost } from './index'

// 获取班级列表
const getClassList = (params) => apiGet('/api/classroom/mobile', params)
// 成员选择列表
const getJohnsonUser = (params) => apiGet('/api/johnson/iep/users/class/user', params)
// 新建班级
const addClassroom = (params) => apiPost('/api/classroom', params)
// 修改班级
const editClassroom = (params) => apiPost(`/api/classroom/update/${params.classId}`, params)
// 解散班级
const dismissClassroom = (params) => apiPost(`/api/classroom/update/status/${params.classId}`, params)
// 转让班级
const transferClassroom = (params) => apiPost('/api/class/user/transfer', params)
// 加入班级
const joinClassRoom = (params) => apiPost('/api/class/user/scan/join', params)
// 移除/退出班级
const exitClassRoom = (params) => apiPost('/api/class/user/exit/class', params)
// 班级详情
const classroomDetails = (params) => apiGet(`/api/classroom/${params.classId}`)

// 用户班级角色权限信息
const classUserPermissions = (params) => apiGet(`/api/class/user/role/${params.classId}/${params.userId}`)

// 添加帖子
const addClassCard = (params) => apiPost('/api/class/post/card', params)
// 编辑帖子
const editClassCard = (params) => apiPost(`/api/class/post/card/update/${params.id}`, params)

// 模拟器下拉列表
const dictionaryList = (params) => apiGet(`/api/sys/data/dictionary/drop/down/list`, params)
// 成员列表
const getUserList = (params) => apiGet(`/api/class/user/mobile`, params)

// 班级成员/发帖量
const classroomCompute = (params) => apiGet(`/api/classroom/compute/${params.classId}`, params)

// 帖子列表
const postCardPage = (params) => apiGet(`/api/class/post/card/mobile/page`, params)

// 帖子通知确认
const userConfirm = (params) => apiPost(`/api/class/user/confirm`, params)

// 帖子详情
const postCardDetails = (postbarId) => apiGet(`/api/class/post/card/mobile/${postbarId}`)

// 班级日历
const cardCalendar = (params) => apiGet(`/api/class/post/card/study/calendar`, params)

// 疾病列表
const diseaseAll = () => apiGet(`/api/cj/disease/all`)

// 新技术列表
const technologyList = (params) => apiGet(`/api/cj/technology/disease/all`, params)

// 旅程列表
const itineraryList = (classId) => apiGet(`/api/class/course/journey/${classId}`)
// 旅程下对应的阶段及课程
const courseList = (params) => apiGet(`/api/class/course/${params.classId}/${params.journeyId}`, params)

// 阶段下课程列表
const stageCoursesList = (params) => apiGet(`/api/class/course/${params.classId}/${params.journeyId}/${params.stageId}`)

// 编辑课程
const courseBatchSave = (params) => apiPost(`/api/class/course/batch/save`, params)

const userClass = (params) => apiGet(`/api/class/user/class/${params.userId}`, params)
// 获取班级id（术者）
const getUserClassId = (userId) => apiGet(`/api/class/user/class/${userId}`)

// 获取用户角色/等级
const getUserPerss = (userId) => apiGet(`/api/johnson/iep/users/role/${userId}`)
// 班级学员选择列表
const getUserClassStudent = (params) => apiGet(`/api/johnson/iep/users/class/student`, params)

// 后台设置白名单
const whiteUser = (params) => apiGet(`/api/classroom/white`, params)

// 删除帖子
const delClassCard = (id, params) => apiPost(`/api/area-postbar/update/part/${id}`, params)
// 选择用户列表
const selectUserList = (params) => apiGet(`/api/class/user/mobile/group/${params.classId}/${params.userId}`)
// 班级分组列表
const addClassGroup = (classId) => apiGet(`/api/class/group/list/${classId}`)

// 课程对应题目数量
const campStudyQuestionNum = (params) => apiGet(`/api/campStudyQuestion/num`, params)
// 选择课程
const changeCourse = (params) => apiGet(`/api/courses/down/list`, params)
// 课程对应题目列表
const campStudyQuestionList = (params) => apiGet(`/api/campStudyQuestion/mobile/list`, params)
// 班级答题
const gradeQuestionList = (params) => apiGet(`/api/class/post/question/topic/detail/${params.postbarId}`, params)
const gradeAnswerQuestion = (params) => apiPost(`/api/class/question/user`, params)

const getIsCorrect = (params) => apiGet(`/api/class/question/user/isCorrect/${params.baseId}/${params.userId}/${params.questionId}`, params)

// 校验是否可以删除班级分组
const checkDelGroup = (params) => apiGet(`/api/class/post/group/rel/have`, params)

// 班级课表列表
const templateList = (params) => apiGet(`/api/class/templates/mobile/page`, params)

// 查看历史班级课表
const templatesHistory = (params) => apiGet(`/api/class/templates/mobile/history/page`, params)

// 删除历史班级课表
const deleteTemplatesHistory = (params) => apiPost(`/api/class/course/table/history/delete`, params)

// 获取班级课表
const getClassCourse = (classId) => apiGet(`/api//class/course/table/mobile/${classId}`)
// 删除课表
const delClassCourse = (params) => apiPost(`/api/class/course/table/mobile/delete`, params)
// 添加课表
const addClassCourse = (params) => apiPost(`/api/class/course/table/mobile`, params)
// 选择课程
const selectClassCourse = (params) => apiGet(`/api/courses/down/list`, params)

// 课程自测
const courseQuestion = (params) => apiGet(`/api/class/post/question/topic/course/${params.courseId}`, params)
const courseQuestionAnswer = (params) => apiGet(`/api//class/post/question/topic/course/answer/${params.courseId}`, params)

const conditions = (params) => apiGet(`/api/class/question/user/exam/condition/${params.userId}/${params.baseId}`, params)
const resetExam = (params) => apiPost(`/api/class/question/user/exam/anew`, params)

const costList = (params) => apiGet(`/api/class/user/mobile/cost`, params)
const examAccuracy = (params) => apiGet(`/api/class/user/mobile/exam/accuracy`, params)
const classUserBusiness = (params) => apiPost(`/api/class/user/business`, params)

export {
  classUserBusiness,
  examAccuracy,
  getClassList,
  getJohnsonUser,
  addClassroom,
  editClassroom,
  dismissClassroom,
  transferClassroom,
  joinClassRoom,
  exitClassRoom,
  classroomDetails,
  classUserPermissions,
  addClassCard,
  editClassCard,
  dictionaryList,
  getUserList,
  classroomCompute,
  postCardPage,
  userConfirm,
  postCardDetails,
  cardCalendar,
  diseaseAll,
  technologyList,
  itineraryList,
  courseList,
  stageCoursesList,
  courseBatchSave,
  userClass,
  getUserClassId,
  getUserPerss,
  getUserClassStudent,
  whiteUser,
  delClassCard,
  selectUserList,
  addClassGroup,
  campStudyQuestionNum,
  changeCourse,
  campStudyQuestionList,
  gradeQuestionList,
  getIsCorrect,
  gradeAnswerQuestion,
  checkDelGroup,
  templateList,
  deleteTemplatesHistory,
  templatesHistory,
  getClassCourse,
  delClassCourse,
  addClassCourse,
  selectClassCourse,
  courseQuestion,
  courseQuestionAnswer,
  conditions,
  resetExam,
  costList
}



// WEBPACK FOOTER //
// ./src/api/grade.js